import { useTranslation } from 'react-i18next';
import { Star, ExternalLink } from 'lucide-react';

interface GoogleReviewCardProps {
  googlePlaceId: string;
}

export function GoogleReviewCard({ googlePlaceId }: GoogleReviewCardProps) {
  const { t } = useTranslation();

  const reviewUrl = `https://search.google.com/local/writereview?placeid=${googlePlaceId}`;

  return (
    <div className="bg-surface border border-hairline rounded-xl p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
          <Star className="w-6 h-6 text-accent fill-accent" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-sans text-lg font-semibold text-ink mb-1">
            {t('googleReview.title')}
          </h3>
          <p className="text-sm text-ink-muted mb-4">
            {t('googleReview.description')}
          </p>
          <a
            href={reviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-accent hover:bg-accent-hover text-on-accent font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-focus"
          >
            <Star className="w-4 h-4 fill-on-accent" aria-hidden="true" />
            {t('googleReview.leaveReview')}
            <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
}
